/* eslint-disable max-len */
/* eslint-disable no-use-before-define */

import getFirebase from 'helper/getFirebase';
import differenceInMinutes from 'date-fns/difference_in_minutes';

import { getDataSyncObjectById } from '../LocalStore';

import { navigatorOnlineCallback } from '../../navigatorOnlineCallback';
import User from '../../currentUser';
// import validateJWT from '../../validateJWT';
// import cookie from '../../cookie';
// import refetchTokens from '../../refetchTokens';

// import userSubscriptionQuery from './userSubscriptionQuery';

// eslint-disable-next-line import/no-cycle
import { initTimeOutDSOsChecker } from './syncStuckDSOs';

const user = new User();

function subscribeWhenOnline(subscriptionCallback) {
  navigatorOnlineCallback('backgroundSyncAndRepair', () => {
    // console.log('online now, subscribe now!');
    subscribe(subscriptionCallback);
    // return clientRef;
  });
}

const removeEntryOfDSOFromFirebase = async dataSyncId => {
  const { firebaseRealTimeDB } = await getFirebase();

  const userId = user.id();

  if (userId && userId.length === 24 && typeof dataSyncId === 'string') {
    firebaseRealTimeDB.ref(`datasync-status/${userId}/${dataSyncId}`).remove();
  }
};

const checkForDeletionAndCallback = async (subscriptionCallback, DSO, dataSyncId) => {
  const localDSO = await getDataSyncObjectById(dataSyncId);

  // if we find a DSO of the same Id in local datasync-Object DB
  if (localDSO) {
    // call subscription callback, inside SyncService.js file
    subscriptionCallback(DSO);

    // remove DSO entry from firebase
    await removeEntryOfDSOFromFirebase(dataSyncId);
  }

  // OR remove DSO entry from firebase if it's older than 59 minutes
  if (DSO.timestamp && differenceInMinutes(new Date().toISOString(), DSO.timestamp) > 59) {
    await removeEntryOfDSOFromFirebase(dataSyncId);
  }
};

const formatResponseAndCallCallback = subscriptionCallback => async childSnapshot => {
  console.log(childSnapshot.key);
  // const userId = user.id();
  const DSO = {
    dataSyncId: childSnapshot.key,
    ...childSnapshot.val()
  };

  await checkForDeletionAndCallback(subscriptionCallback, DSO, childSnapshot.key);
};

async function subscribe(subscriptionCallback) {
  if (!navigator.onLine) {
    console.log('offline now, waiting for subscribe');
    subscribeWhenOnline(subscriptionCallback);
    return null;
  }
  const userId = user.id();
  initTimeOutDSOsChecker();

  const { firebaseRealTimeDB } = await getFirebase();
  const DSOUserRef = firebaseRealTimeDB.ref(`datasync-status/${userId}`);
  DSOUserRef.on('child_added', formatResponseAndCallCallback(subscriptionCallback));

  return true;
}

export const initBgSyncServiceFirebase = subscriptionCallback => {
  subscribe(subscriptionCallback);
};
